import { render, staticRenderFns } from "./MoreQuestions.vue?vue&type=template&id=4df665af&"
import script from "./MoreQuestions.vue?vue&type=script&lang=js&"
export * from "./MoreQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports